var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{ref:"tlp",staticClass:"tooltip",attrs:{"content":_vm.text,"effect":"dark","disabled":!_vm.tooltipFlag,"placement":_vm.placement}},[_c('span',{class:_vm.className,on:{"mouseenter":function($event){return _vm.visibilityChange($event)}}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }